export default __webpack_public_path__ + "static/media/step4.fadbb8d0.png";